/**
 * Created by evgeny on 15.05.2024
 */

const OldPiggyBankGoalView = cc.Node.extend({
    ctor: function (goal) {
        this._super();
        this.setAnchorPoint(0.5, 0.5);
        const styles = cleverapps.styles.OldPiggyBankGoalView;

        const parts = this.parseText(goal);
        this.createGoalIcon(parts[0]);
        cleverapps.UI.wrap(this);

        const amount = cleverapps.UI.generateImageText(parts[1], cleverapps.styles.FONTS.OLD_PIGGY_BANK_GOAL_FONT);
        this.addChild(amount);
        amount.setAlignment(styles.amount);
        this.amount = Number.parseInt(parts[1]);
    },

    createGoalIcon: function (key) {
        const icon = this.createIcon(key);

        this.light = new cleverapps.Spine(bundles.piggy_bank.jsons.coin_light);
        this.light.setSkin("yellow");
        this.addChild(this.light);

        this.addChild(icon);
    },

    parseText: function (string) {
        string.trim();

        const parts = [];
        parts.push(string.substring(0, 2));
        parts.push(string.substring(2, string.length));
        return parts;
    },

    showLight: function () {
        this.light && this.light.setAnimation(0, "multiple", false);
        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.1),
            cleverapps.effects.fireAction("piggybank.coins.light")
        ));
    },

    createIcon: function (key) {
        const image = this.chooseImage(key);

        const icon = new cc.Sprite(image);

        icon.setScale(OldPiggyBankGoalView.ICONS[key].scale);

        return icon;
    },

    chooseImage: function (key) {
        const selected = OldPiggyBankGoalView.ICONS[key];
        return bundles[selected.bundle].frames[selected.name];
    }
});

OldPiggyBankGoalView.ICONS = {
    "$$": {
        name: "gold_icon_png",
        bundle: "buttons_inlined_icons",
        scale: 1
    },

    "@@": {
        name: "coin_icon_png",
        bundle: "buttons_inlined_icons",
        scale: 1
    }
};

cleverapps.styles.FONTS.OLD_PIGGY_BANK_GOAL_FONT = {
    size: 35,
    color: new cc.Color(0xFF, 0xE2, 0x40, 0xFF)
};

cleverapps.styles.OldPiggyBankGoalView = {
    amount: {
        x: { align: "center" },
        y: { align: "center", dy: -50 }
    }
};